import styled from 'styled-components';


const Button = styled.button<{ error?: boolean }>`
  padding: 10px 35px;
  text-transform: uppercase;
  border-radius: 60px;
  min-height: 58px;
  cursor: pointer;
  outline: none;
  color: white;
  min-width: 208px;
  border: 2px solid ${({ theme, error }) => (error ? theme.colors.gray : theme.colors.orange)};
  background-color: ${({ theme, error }) => (error ? theme.colors.gray : theme.colors.orange)};
  transition: all 300ms ease-in-out;
  white-space: nowrap;
  box-shadow: 4px 4px 11px rgba(0, 0, 0, 0.2);
  &:hover, 
  &:focus {
    color: ${({ theme, error }) => (error ? theme.colors.white : theme.colors.orange)};
    background-color: ${({ theme, error }) => (error ? theme.colors.gray : theme.colors.white)};
  }
`;


export default Button;
